import { useEffect, useState } from "react";
import api from "@/utils/axios-utils";

export interface ContactInfo {
  name: string | null;
  email: string | null;
}

export interface CoTeacherInfo {
  teacher_id: number;
  user_id: number;
  name: string | null;
  email: string | null;
}

export interface Profile {
  id: number;
  name: string | null;
  email: string | null;
  account_role: string;
  organization_id: string | null;
  org_admin_contact: ContactInfo | null;
  coteachers: CoTeacherInfo[];
}

export const useProfile = (enabled: boolean) => {
  const [profile, setProfile] = useState<Profile | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    setIsLoading(true);
    api
      .get<Profile>("/accounts/me")
      .then((res) => {
        if (!cancelled) setProfile(res.data);
      })
      .catch(() => {
        if (!cancelled) setProfile(null);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { profile, isLoading };
};
